import { render, staticRenderFns } from "./update-coursetype.html?vue&type=template&id=5bec78d5&scoped=true&"
import script from "./update-coursetype.js?vue&type=script&lang=js&"
export * from "./update-coursetype.js?vue&type=script&lang=js&"
import style0 from "./update-coursetype.scss?vue&type=style&index=0&id=5bec78d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec78d5",
  null
  
)

export default component.exports